export enum UserEventObject {
  BENEFICJENT = 'Konto użytkownika',
  SYSTEM = 'System',
}
